// Punktide arvutamise loogika — peegeldab Exceli valemeid

// Arvuta punktid ühe mängu kohta
// result: "2-1" (alagrupid) või "2-1 (N)" (playoff)
// prediction: "2-1" (alagrupid) või "2-1" (playoff skoor)
// nep: "N" | "E" | "P" (ainult playoff)
// isPlayoff: boolean
export function calcPoints(result, prediction, nep = "", isPlayoff = false) {
  if (!result || !prediction) return null;

  const parseScore = (s) => {
    const clean = s.trim().split(" ")[0]; // eemaldab (N)/(E)/(P) osa
    const parts = clean.split("-");
    if (parts.length !== 2) return null;
    const h = parseInt(parts[0]);
    const a = parseInt(parts[1]);
    if (isNaN(h) || isNaN(a)) return null;
    return { h, a };
  };

  const r = parseScore(result);
  const p = parseScore(prediction);
  if (!r || !p) return null;

  const outcome = (sc) => sc.h > sc.a ? 1 : sc.h < sc.a ? -1 : 0;

  let pts = 0;

  // Õige tulemus (võit/viik/kaotus) = 3p
  if (outcome(r) === outcome(p)) pts += 3;

  // Täpne skoor = +2p
  if (r.h === p.h && r.a === p.a) pts += 2;

  // Playoff N/E/P = +2p
  if (isPlayoff && nep) {
    const resultNep = extractNep(result);
    if (resultNep && resultNep === nep.toUpperCase()) pts += 2;
  }

  return pts;
}

// Eraldab N/E/P tulemusest ("2-1 (N)" → "N", "2-1 N" → "N")
export function extractNep(result) {
  if (!result) return null;
  const parts = result.trim().split(" ");
  if (parts.length >= 2) {
    // Eemalda sulud, kui need on olemas: "(N)" -> "N"
    const raw = parts[parts.length - 1].toUpperCase().replace(/[()]/g, "");
    if (["N", "E", "P"].includes(raw)) return raw;
  }
  return null;
}

// Valideeri skoori sisestus ("2-1", "10-0" jne)
export function isValidScore(s) {
  if (!s) return false;
  const clean = s.trim();
  const match = clean.match(/^(\d{1,2})-(\d{1,2})$/);
  if (!match) return false;
  const h = parseInt(match[1]);
  const a = parseInt(match[2]);
  return h >= 0 && h <= 20 && a >= 0 && a <= 20;
}

// Formateeri tulemus kuvamiseks
export function formatScore(result) {
  if (!result) return "—";
  return result.trim();
}

// Kas mäng on juba toimunud (tulemus olemas)?
export function isMatchDone(result) {
  return !!(result && result.trim().length > 0);
}
